import { useDictionary } from "@adamlip/okeoke.client";
import { Button } from "@nextui-org/react";
import OrderList from "components/OrderList";
import { useNavigate } from "react-router-dom";
import { AppParamsContext } from "contexts/AppParamsContext";
import { useContext } from "react";

export default function OrderHistory({ onSelect }) {
  const { getValue } = useDictionary();
  const { appParams } = useContext(AppParamsContext);
  let navigate = useNavigate();

  const handleClick = () => {
    if (typeof onSelect === "function") onSelect();
    navigate("/history");
  };

  return (
    <>
      <div
        className={`${
          appParams?.styles?.fonts?.capitalize ? "font-extrabold uppercase" : ""
        } font-bold text-lg`}
      >
        {getValue("app_v2_last_five_orders")}
      </div>
      <div className="grow overflow-auto">
        <OrderList limit={5} limitDays={14} />
      </div>
      <Button
        className={`shrink-0 ${
          appParams?.styles?.fonts?.capitalize ? "font-extrabold uppercase" : ""
        }`}
        color="primary"
        onClick={() => handleClick()}
      >
        {getValue("app_v2_goToOrderHistory")}
      </Button>
    </>
  );
}
